import React from "react";
import "./AIStrategyFlow.css";

const partnerLogos = [
  {
    id: "aknu",
    name: "Adikavi Nannaya University",
    displayName: "ADIKAVI NANNAYA UNIVERSITY",
    logo: "/assests/aknu-logo.svg",
    desc: "Premier state university in Rajahmundry advancing multidisciplinary higher education and research.",
    url: "https://www.aknu.edu.in/",
  },
  {
    id: "anr",
    name: "ANR Colleges Gudivada",
    displayName: "ANR COLLEGES GUDIVADA",
    logo: "/assests/anr-logo.svg",
    desc: "Historic higher educational institution in Gudivada empowering students with multidisciplinary learning.",
    url: "https://anrcollege.edu/",
  },
  {
    id: "verve",
    name: "Verve Kitchens",
    displayName: "VERVE KITCHENS",
    logo: "/assests/verve-logo.png",
    desc: "Premium modular wardrobes, customized modular kitchens, and contemporary interior solutions in Vijayawada.",
    url: "https://vervekitchens.com/",
  },
  {
    id: "byteskills",
    name: "Byte Skills Technologies",
    displayName: "BYTE SKILLS TECHNOLOGIES",
    logo: "/assests/byteskills.png",
    desc: "Innovative IT training, workforce upskilling, and tech enterprise enablement platform.",
    url: "https://byteskillstech.com/",
  },
  {
    id: "geoinfy",
    name: "Geo Infy Solutions",
    displayName: "GeoInfy Solutions",
    logo: "/assests/geo.jpg",
    desc: "Next-generation geospatial intelligence, GIS mapping solutions, and software systems.",
    url: "https://geoinfy.com/",
  },
  {
    id: "pinkmoon-edu",
    name: "Pinkmoon Overseas Education",
    displayName: "PINKMOON OVERSEAS EDUCATION",
    logo: "/assests/pinkmoonn.jpg",
    desc: "Global educational consultancy guiding students toward top international university admissions.",
    url: "https://global.pinkmoontech.com/",
  },
  {
    id: "nuhvin",
    name: "Nuhvin Global Services",
    displayName: "NUHVIN GLOBAL SERVICES",
    logo: "/assests/nuhvin.png",
    desc: "Global IT services, digital transformation consulting, and enterprise software delivery.",
    url: "https://brainwavesdigital.com/",
  },
  {
    id: "veda",
    name: "Veda Degree Colleges",
    displayName: "VEDA DEGREE COLLEGES",
    logo: "/assests/veda.jpg",
    desc: "Renowned collegiate education group providing quality undergraduate and graduate programs.",
    url: "https://veda.ifox.in/",
  },
  {
    id: "curio",
    name: "Curio Digital Therapeutics",
    displayName: "CURIO DIGITAL THERAPEUTICS",
    logo: "/assests/curio.avif",
    desc: "Digital therapeutics pioneer developing evidence-based medical software for women's health.",
    url: "https://www.curiodigitaltx.com/",
  },
  {
    id: "jeevasolar",
    name: "Jeeva Adithya Solar",
    displayName: "JEEVA ADITHYA SOLAR",
    logo: "/assests/jeevasolar-logo.svg",
    desc: "Renewable solar energy and photovoltaic power systems provider for green infrastructure.",
    url: "http://www.jeevadhityasolar.com/",
  },
  {
    id: "maximal",
    name: "Maximal Energy Pvt. Ltd.",
    displayName: "MAXIMAL ENERGY PVT. LTD.",
    logo: "/assests/maximal-logo.svg",
    desc: "Turnkey solar EPC, BESS energy storage systems, architectural design, and sustainable construction solutions.",
    url: "https://www.themaximalenergy.com/",
  },
  {
    id: "spacedesigns",
    name: "Space Designs",
    displayName: "SPACE DESIGNS",
    logo: "/assests/spacedesigns-logo.png",
    desc: "Premier residential and commercial interior design and modular spaces firm in Vijayawada.",
    url: "https://spacedesigns.net/",
  },
  {
    id: "venkataramana",
    name: "Venkata Ramana Travels",
    displayName: "VENKATA RAMANA TRAVELS",
    logo: "/assests/venkataramana-logo.svg",
    desc: "Reliable passenger transportation, luxury coach fleet, and regional travel logistics.",
    url: "https://srivenkataramanatravels.com/",
  },
  {
    id: "h2",
    name: "H² Solutions",
    displayName: (
      <>
        H<sup>2</sup> SOLUTIONS
      </>
    ),
    logo: "/assests/h2-logo.svg",
    desc: "Next-generation hydrogen energy and advanced high-tech process engineering solutions.",
    url: "https://h2solutions.tech/",
  },
  {
    id: "goldenkeys",
    name: "Golden Keys",
    displayName: "GOLDEN KEYS",
    logo: "/assests/goldenkeys-logo.svg",
    desc: "Premier real estate, luxury property advisory, and hospitality management services.",
    url: "https://goldenkeys.in/",
  },
];

function AIStrategyFlow() {
  const row1 = partnerLogos.slice(0, 6);
  const row2 = partnerLogos.slice(6, 12);
  const row3 = partnerLogos.slice(12, 15);

  const renderCard = (partner) => (
    <a
      key={partner.id}
      href={partner.url}
      target="_blank"
      rel="noopener noreferrer"
      className="ai-collaboration-card"
    >
      <div className="collaboration-logo-box">
        <img
          src={partner.logo}
          alt={partner.name}
          className="collaboration-logo-img"
        />
      </div>
      <span className="collaboration-card-title">{partner.displayName}</span>
      <p className="collaboration-card-desc">{partner.desc}</p>
    </a>
  );

  return (
    <section className="ai-grid-section">
      <div className="ai-strategy-header section-header">
        <div className="ai-strategy-label section-label">
          <svg
            className="ai-strategy-label-icon"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
              fill="currentColor"
            />
          </svg>
          <span>Trusted by</span>
        </div>
        <h2 className="ai-strategy-title section-title">Trusted by</h2>
        <p className="ai-strategy-subtitle section-description">
          We believe great things happen when we work together. Join forces with
          our team and make an impact.
        </p>
      </div>

      <div className="ai-grid-container">
        {/* Row 1 (First 6 in a row) */}
        <div className="ai-grid-row ai-grid-row-6">
          {row1.map(renderCard)}
        </div>

        {/* Row 2 (Second 6 in a row) */}
        <div className="ai-grid-row ai-grid-row-6">
          {row2.map(renderCard)}
        </div>

        {/* Row 3 (Remaining 3 in down row) */}
        <div className="ai-grid-row ai-grid-row-3">
          {row3.map(renderCard)}
        </div>
      </div>
    </section>
  );
}

export default AIStrategyFlow;
